import React from "react";

function Footer() {
  return (
    <div className="foot fl">
      <div className="foot-left">
        <p>
          浙江工业大学计算机科学与技术学院，杭州 310023
          <br />
          城市科学与社会计算研究组(The CSSC Lab)
          <br />
          电子邮箱：NingLi68@outlook.com
        </p>
        <p style={{ fontStyle: "italic" }}>网页设计: 李宁 &amp; 朱秉</p>
      </div>
    </div>
  );
}

export { Footer };
